import { createSelectorHook } from '../../utils/selectors';
import { initialState } from './reducers';

export const selectDomain = (state) => state.auth || initialState;

export const [selectAuthenticatedUser, useAuthenticatedUser] =
	createSelectorHook(
		selectDomain,
		({ authenticatedUser }) => authenticatedUser
	);

export const [selectImpersonatedUser, useImpersonatedUser] = createSelectorHook(
	selectDomain,
	({ impersonatedUser }) => impersonatedUser
);

export const [selectIsImpersonating, useIsImpersonating] = createSelectorHook(
	selectDomain,
	({ isImpersonating }) => isImpersonating
);

export const [selectAuthState, useAuthState] = createSelectorHook(
	selectDomain,
	(authState) => authState
);

export const [selectAccessToken, useAccessToken] = createSelectorHook(
	selectDomain,
	({ accessToken }) => accessToken
);

export const [selectIdToken, useIdToken] = createSelectorHook(
	selectDomain,
	({ idToken }) => idToken
);

export const [selectIsAuthenticated, useIsAuthenticated] = createSelectorHook(
	selectDomain,
	({ isAuthenticated }) => isAuthenticated
);

export const [selectCurrentUser, useCurrentUser] = createSelectorHook(
	selectDomain,
	({ isImpersonating, impersonatedUser, authenticatedUser }) =>
		isImpersonating ? impersonatedUser : authenticatedUser
);

export const [selectUserSecret, useUserSecret] = createSelectorHook(
	selectCurrentUser,
	(currentUser) => currentUser?.userSecret
);
